<div class="custom-header" (dblclick)="toggleRollupGroup()">
  <span class="header-title" *ngIf="isRollupHeader===false">
    <span class="group-name" title="{{params.valueFormatted}}">{{params.valueFormatted}}</span>
    <span class="nhtp-link" *ngIf="this.newHireTrainingWeeks>0 && showNhtpLink"><a id="training-period" href="#" (click)="this.showNhtpDialog($event)">{{this.newHireTrainingWeeks}} {{"multi.mu.group.nhtp"|translate}}</a></span>
    <span class="nhtp-link" *ngIf="this.newHireTrainingWeeks==0 && showNhtpLink"><a id="training-period" href="#" (click)="this.showNhtpDialog($event)">{{"multi.mu.group.nhtp.no.value"|translate}}</a></span>
  </span>
  <span class="ag-group-expanded" *ngIf="isRollupHeader && !isRollupCollapsed" (click)="this.toggleRollupGroup()">
    <span class="ag-icon ag-icon-tree-open">
    </span>
  </span>
  <span class="ag-group-contracted" *ngIf="isRollupHeader && isRollupCollapsed"  (click)="this.toggleRollupGroup()">
    <span class="ag-icon ag-icon-tree-closed">
    </span>
  </span>
  <span *ngIf="isRollupHeader" title='{{"multi.mu.rollup.group.header" | translate}}'>{{"multi.mu.rollup.group.header" | translate}}</span>
  <!-- Add any custom elements you want here -->
</div>
